module.exports = {"360729100":"城厢镇","360729101":"大吉山镇","360729102":"陂头镇","360729103":"金龙镇","360729104":"南迳镇","360729105":"龙源坝镇","360729200":"中寨乡","360729201":"社迳乡","360729202":"龙下乡","360729402":"全南县工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360729.json
// module id = 1296
// module chunks = 0